import React, { useEffect, useState } from "react";
import { CreateProductType } from "../../types";
import { useAddProductMutation } from "../../../../../hooks/ProductsManagement/useAddProductMutation";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import PriceInput from "Components/PriceInput";
import { formatNumberWithCommas } from "utils/formatNumberWithCommas";
import { Dropdown, MenuProps, Spin } from "antd";
import { Icon } from "@iconify-icon/react";
import { useGetMeasurements } from "hooks/Measurement/useGetMeasurements";

const ShippingAndInventoryForm = ({
  setActive,
  handleInputChange,
  handleNumberInputChange,
  payload,
  setPayload,
  edit,
}: {
  setActive: any;
  handleInputChange: any;
  handleNumberInputChange: any;
  payload: CreateProductType;
  setPayload: any;
  edit?: boolean;
}) => {
  const [validity, setValidity] = useState(false);
  const { mutateAsync, isPending } = useAddProductMutation();
  const navigate = useNavigate();

  const handleSubmit = () => {
    mutateAsync(payload, {
      onSuccess: () => {
        navigate("/product-management");
      },
    });
  };

  const { data: measurements } = useGetMeasurements();

  const itemTwo: MenuProps["items"] =
    measurements?.data?.flatMap((measurement: any, index: any) => [
      {
        label: measurement.label,
        key: String(index),
        onClick: () =>
          setPayload((prevState: any) => ({
            ...prevState,
            unitStockMeasurement: measurement.label,
          })),
      },
      { type: "divider" },
    ]) || [];

  const bulkItem: MenuProps["items"] =
    measurements?.data?.flatMap((measurement: any, index: any) => [
      {
        label: measurement.label,
        key: String(index),
        onClick: () =>
          setPayload((prevState: any) => ({
            ...prevState,
            bulkStockMeasurement: measurement.label,
          })),
      },
      { type: "divider" },
    ]) || [];

  useEffect(() => {
    const {
      name,
      unitPrice,
      bulkPrice,
      unitStockMeasurement,
      bulkStockMeasurement,
    } = payload;

    const requiredFieldsValid = Boolean(
      name &&
        unitPrice &&
        bulkPrice &&
        unitStockMeasurement &&
        bulkStockMeasurement
    );
    setValidity(requiredFieldsValid);
  }, [payload]);

  return (
    <div className="mx-auto max-w-[700px] border-[1px] border-[#eeeeee] rounded-[10px] mt-[20px]">
      <div className="p-[20px] font-medium border-b-[1px] border-[#eeeeee]">
        Stock Measurement
      </div>
      <div className="p-[20px]">
        <div className="flex gap-2">
          <div className="w-6/12">
            <label
              htmlFor="unitStockMeasurement"
              className="mt-[30px] text-grey"
            >
              Unit Measurement
            </label>
            <Dropdown menu={{ items: itemTwo }} trigger={["click"]}>
              <div
                onClick={(e) => e.preventDefault()}
                className="mt-2 p-3 mb-3 text-[16px] bg-white w-full flex justify-between items-center border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              >
                {payload?.unitStockMeasurement || "Select Unit"}
                <Icon
                  icon="iconamoon:arrow-down-2-duotone"
                  width={20}
                  color="#474747"
                />
              </div>
            </Dropdown>
          </div>
          <div className="w-6/12">
            <PriceInput
              label="Unit Weight"
              name="unitWeight"
              value={formatNumberWithCommas(payload?.unitWeight)}
              onChange={handleNumberInputChange}
              placeholder=""
            />
          </div>
          {/* <div className="w-4/12">
            <PriceInput
              label="Low Unit Stock"
              name="lowUnitStock"
              value={formatNumberWithCommas(payload?.lowUnitStock)}
              onChange={handleNumberInputChange}
              placeholder=""
            />
          </div> */}
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <label
              htmlFor="bulkWeight"
              className="block mb-2 text-grey text-[16px] manrope capitalize"
            >
              Bulk Measurement
            </label>
            <Dropdown menu={{ items: bulkItem }} trigger={["click"]}>
              <div
                onClick={(e) => e.preventDefault()}
                className="p-3 mb-3 text-[16px] bg-white w-full flex justify-between items-center border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
              >
                {payload?.bulkStockMeasurement || "Select Unit"}
                <Icon
                  icon="iconamoon:arrow-down-2-duotone"
                  width={20}
                  color="#474747"
                />
              </div>
            </Dropdown>
          </div>
          <div className="w-6/12">
            <PriceInput
              label="Bulk Weight"
              name="bulkWeight"
              value={formatNumberWithCommas(payload?.bulkWeight)}
              onChange={handleNumberInputChange}
              placeholder=""
            />
          </div>
          {/* <div className="w-4/12">
            <PriceInput
              label="Bulk Price"
              name="bulkPrice"
              value={formatNumberWithCommas(payload?.bulkPrice)}
              onChange={handleNumberInputChange}
              placeholder=""
            />
          </div> */}
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <PriceInput
              label="Betty Min. Bulk Shipping (Optional)"
              name="bulkShippingMinQtyBetty"
              value={formatNumberWithCommas(payload?.bulkShippingMinQtyBetty)}
              onChange={handleNumberInputChange}
              placeholder="Enter Price"
            />
          </div>
          <div className="w-6/12">
            <PriceInput
              label="Betty Max. Bulk Shipping (Optional)"
              name="bulkShippingMaxQtyBetty"
              value={formatNumberWithCommas(payload?.bulkShippingMaxQtyBetty)}
              onChange={handleNumberInputChange}
              placeholder="Enter Price"
            />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <PriceInput
              label="Uber Min. Bulk Shipping (Optional)"
              name="bulkShippingMinQtyUber"
              value={formatNumberWithCommas(payload?.bulkShippingMinQtyUber)}
              onChange={handleNumberInputChange}
              placeholder="Enter Price"
            />
          </div>
          <div className="w-6/12">
            <PriceInput
              label="Uber Max. Bulk Shipping (Optional)"
              name="bulkShippingMaxQtyUber"
              value={formatNumberWithCommas(payload?.bulkShippingMaxQtyUber)}
              onChange={handleNumberInputChange}
              placeholder="Enter Price"
            />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <PriceInput
              label="Walk in Min. Bulk Shipping (Optional)"
              name="bulkShippingMinQtyWalkIn"
              value={formatNumberWithCommas(payload?.bulkShippingMinQtyWalkIn)}
              onChange={handleNumberInputChange}
              placeholder=""
            />
          </div>
          <div className="w-6/12">
            <PriceInput
              label="Walk in Max. Bulk Shipping (Optional)"
              name="bulkShippingMaxQtyWalkIn"
              value={formatNumberWithCommas(payload?.bulkShippingMaxQtyWalkIn)}
              onChange={handleNumberInputChange}
              placeholder=""
            />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="w-6/12">
            <PriceInput
              label="Low Unit Stock (Optional)"
              name="lowUnitStock"
              value={formatNumberWithCommas(payload?.lowUnitStock)}
              onChange={handleNumberInputChange}
              placeholder=""
            />
          </div>
          <div className="w-6/12">
            <PriceInput
              label="Low Bulk Stock (Optional)"
              name="lowBulkStock"
              value={formatNumberWithCommas(payload?.lowBulkStock)}
              onChange={handleNumberInputChange}
              placeholder=""
            />
          </div>
        </div>
        <button
          onClick={handleSubmit}
          disabled={!validity || isPending}
          className={`text-white p-[23px] w-full font-bold rounded-md ease-in-out duration-300 ${
            !validity || isPending
              ? "bg-brown opacity-50 cursor-not-allowed"
              : "bg-orange"
          }`}
        >
          {isPending ? (
            <Spin
              className="text-white"
              size="default"
              indicator={<LoadingOutlined spin />}
            />
          ) : (
            "Submit"
          )}
        </button>

        {/* <button
          onClick={() => {
            if (!isFormIncomplete() && !isPending) {
              handleSubmit();
            }
          }}
          className={`text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300 ${
            validity || isPending
              ? "bg-brown opacity-50 cursor-not-allowed"
              : "bg-orange"
          }`}
          disabled={validity || isPending}
        >
          {edit ? "Submit" : "Complete"}
        </button> */}
      </div>
    </div>
  );
};

export default ShippingAndInventoryForm;
